import { useContext, useEffect, useState } from 'react';
import PlansHeader from './header';
import SelectPlan from './selectPlan';
import { IModelPlans } from './types';
import {
    SegmentEventPageTypes,
    SegmentEventPages,
    PRODUCT,
    SUB_PRODUCT_NAME,
    SegmentEventNameTypes,
} from 'utils/segment/constants';
import { MPosContext } from 'utils/context';
import { useSegmentViewEvents } from 'hooks/useSegmentView';
import { useViewport } from 'utils/responsive';
import { PageLoader } from 'utils/styles';
import { getImageBasePath } from 'utils/generics';
import ErrorPage from 'widgets/errorScreen';
import * as Styles from './styles';

function Plans() {
    const { partnerId, planDetails, permissions } = useContext(MPosContext);

    const [showError, setShowError] = useState(false);
    const [plans, setPlans] = useState<IModelPlans[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    const { isMobile } = useViewport();

    /**
     * view segment hook
     */
    useSegmentViewEvents(SegmentEventNameTypes.VIEW, {
        page_url: typeof window !== 'undefined' ? window.location.href : '',
        page_type: SegmentEventPageTypes.MAIN_PAGE,
        view_name: SegmentEventPages.VIEW_PLAN,
        product: PRODUCT,
        sub_product_name: SUB_PRODUCT_NAME,
        platform: isMobile ? 'mweb' : 'web',
        referrer: document.referrer || '',
        device: navigator.userAgent || '',
        partner: partnerId,
    });

    useEffect(() => {
        if (planDetails.device.is_device_verified_in_model_page) {
            import('./apis').then(async (req) => {
                const { status, plans } = await req.getEligiblePLans(
                    partnerId,
                    planDetails.device.id,
                    planDetails.device.activation_date,
                    planDetails.device.serial_number,
                    permissions.group
                );
                if (status && plans.length > 0) {
                    setPlans(plans);
                    setShowError(false);
                } else {
                    setShowError(true);
                }
                setIsLoading(false);
            });
        } else {
            import('./apis').then(async (req) => {
                const { status, plans } = await req.getModelPlans(
                    partnerId,
                    planDetails.device.id,
                    permissions.group
                );
                if (status) {
                    setPlans(plans);
                    setShowError(false);
                } else {
                    setShowError(true);
                }
                setIsLoading(false);
            });
        }
    }, []);

    if (showError) {
        return (
            <ErrorPage
                hideHeader={true}
                showEditDeviceHeader={true}
                errorMessage={'No Plans are eligible for this model'}
            />
        );
    }

    return (
        <Styles.Wrapper>
            <PlansHeader />
            {isLoading ? (
                <PageLoader src={getImageBasePath('/gif/pageLoader.gif')} />
            ) : plans.length === 0 ? (
                <ErrorPage
                    hideHeader={true}
                    errorMessage={'Sorry no plan available for this model now'}
                />
            ) : (
                <SelectPlan plans={plans} />
            )}
        </Styles.Wrapper>
    );
}

export default Plans;
